import React, { useState } from 'react';
import { DollarSign, X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

/**
 * Compact info bubble shown in publish modals (Gim Toli, Podcast, Film court).
 * Informs users that monetization unlocks at 5 000 followers.
 * Pure info: no action, no gate, no API call.
 */
const MonetizationInfoBubble = () => {
  const { t } = useLanguage();
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  const title = t('monetization.info_title') || 'Monétisation';
  const body =
    t('monetization.info_body') ||
    'À partir de 5 000 abonnés, vous pouvez attacher un sponsor à vos contenus et recevoir des paiements directs en plus de 15 devises.';
  const cta = t('monetization.info_cta') || 'En savoir plus';

  return (
    <div
      data-testid="monetization-info-bubble"
      className="relative flex gap-3 items-start rounded-xl border border-amber-400/30 bg-gradient-to-br from-amber-500/10 to-yellow-500/5 p-3 text-amber-100"
    >
      <div className="shrink-0 mt-0.5">
        <div className="w-8 h-8 rounded-full bg-amber-400/20 flex items-center justify-center">
          <DollarSign className="w-4 h-4 text-amber-300" />
        </div>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold leading-tight">{title}</p>
        <p className="text-xs text-amber-100/80 mt-0.5 leading-snug">{body}</p>
        <a
          href="https://info.destine.studio/document"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="monetization-info-link"
          className="inline-block mt-1 text-xs underline text-amber-200 hover:text-amber-100"
        >
          {cta}
        </a>
      </div>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="dismiss"
        data-testid="monetization-info-dismiss"
        className="shrink-0 -mt-1 -mr-1 p-1 rounded-md hover:bg-white/10 text-amber-200/70 hover:text-amber-100"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

export default MonetizationInfoBubble;
